import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { WarningAmberRounded } from "@mui/icons-material";

export default function AttemptWarningDialog({
  open,
  variant,
  questionNumber,
  isLastQuestion,
  onPrimary,
}) {
  const isFinal = variant === "final";

  const title = isFinal ? "Maximum Attempts Reached" : "Re-recording Detected";
  const iconColor = isFinal ? "#ef4444" : "#f59e0b";
  const buttonLabel = isFinal
    ? isLastQuestion
      ? "OK, Submit Interview"
      : "OK, Move to Next Question"
    : "OK, Continue Recording";

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      onClose={() => {}}
      disableEscapeKeyDown
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}>
        <WarningAmberRounded sx={{ color: iconColor, fontSize: 28 }} />
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.primary" }}>
          {isFinal ? (
            <>
              You have reached the maximum number of recording attempts for{" "}
              <strong>Question {questionNumber}</strong>. Your latest response will be saved, and you will now proceed to{" "}
              {isLastQuestion ? "interview submission." : "the next question."}
            </>
          ) : (
            <>
              This is your final attempt for recording your response for{" "}
              <strong>Question {questionNumber}</strong>.
              {isLastQuestion
                ? " If the page is refreshed again, your current response will be saved automatically and you will be moved to interview submission."
                : " If the page is refreshed again, your current response will be saved automatically and you will be moved to the next question."}
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color={isFinal ? "error" : "primary"}
          fullWidth
          onClick={onPrimary}
          sx={{ textTransform: "none", borderRadius: 1.5 }}
        >
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

